import { useShortcutPressListener } from "../../hooks/useShortcutPressListener";

import ChangeTabs from "./ChangeTabs";
import Navigations from "./Navigations";
import OpenInNewTab from "./OpenInNewTab";
import PrimaryCTA from "./PrimaryCTA";

export default function CommandbarFooter() {
  useShortcutPressListener();

  return (
    <div className="p-3 border-t border-t-core-silver-a3 text-light flex items-center justify-between">
      <div className="flex items-center gap-5">
        <ChangeTabs />
        <Navigations />
      </div>

      <div className="flex items-center gap-5">
        <OpenInNewTab />
        <PrimaryCTA />
      </div>
    </div>
  );
}
